import React, { useState } from 'react';
import { ExperimentCookie } from 'types/common';
import {
  CategoryImageSection,
  Modal,
  ModalContent,
  ModalHeader,
  Typography,
} from 'common/components';
import {
  STORAGE_CDN_PATH,
  STORAGE_ELEMENT_BLOCK,
} from '../../storage-constants';

const MODAL_CONTENT = [
  {
    title: 'Хотите увидеть, как может выглядеть ваш интерьер, ещё до покупки мебели? ',
    description: 'Мы набросаем идеи для вашего пространства за час — и это абсолютно бесплатно. Вы получите готовую картинку, где стены, пол и мебель гармонично сочетаются между собой.',
  },
  {
    title: 'Хочется перемен здесь и сейчас? ',
    description: 'Обратите внимание на наши готовые комплекты — привезём их к вам домой всего за 7 дней. Просто выберите стиль, который нравится, а мы позаботимся о быстрой доставке и монтаже.',
  },
  {
    title: 'У вас нестандартная планировка или особые пожелания? ',
    description: 'Мы сделаем мебель точно под ваши размеры, чтобы она идеально вписалась в ваш дом и стиль интерьера — такой проект займёт всего 21 день.',
  },
  {
    title: 'Именно столько семей доверились нам и уже живут с нашей мебелью. ',
    description: 'Каждый проект — это чья-то спальня, кухня или гостиная, которую мы сделали удобной, стильной и функциональной.',
  },
];

export const StorageCategories: React.FC<{ variant: ExperimentCookie }> = ({ variant }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeCard, setActiveCard] = useState<number>(0);

  const handleCardClick = (cardIndex: number) => {
    setIsOpen(true);
    setActiveCard(cardIndex);
  }

  const handleCloseModal = () => {
    setIsOpen(false);
    setActiveCard(0)
  };

  let path = 'category-images';
  if (variant === 'C') {
    path += '/c'
  }

  return (
    <>
      <CategoryImageSection
        categories={[
          {
            imgAlt: 'Карточка Бесплатный дизайн-проект',
            title: 'Бесплатный дизайн-проект за\u00A0час',
            srcD: `${STORAGE_CDN_PATH}/${path}/1-d.png/1-d.png`,
            srcT: `${STORAGE_CDN_PATH}/${path}/1-t.png/1-t.png`,
            src: `${STORAGE_CDN_PATH}/${path}/1-m.png/1-m.png`,
          },
          {
            imgAlt: 'Карточка Готовые комплекты',
            title: 'Готовые комплекты за\u00A07\u00A0дней',
            srcD: `${STORAGE_CDN_PATH}/${path}/2-d.png/2-d.png`,
            srcT: `${STORAGE_CDN_PATH}/${path}/2-t.png/2-t.png`,
            src: `${STORAGE_CDN_PATH}/${path}/2-m.png/2-m.png`,
          },
          {
            imgAlt: 'Карточка Мебель на заказ',
            title: 'Мебель на\u00A0заказ по\u00A0точным размерам за 21 день',
            srcD: `${STORAGE_CDN_PATH}/${path}/3-d.png/3-d.png`,
            srcT: `${STORAGE_CDN_PATH}/${path}/3-t.png/3-t.png`,
            src: `${STORAGE_CDN_PATH}/${path}/3-m.png/3-m.png`,
          },
          {
            imgAlt: 'Карточка Более 250 000 реализованных проектов',
            title: 'Более 250 000 реализованных проектов',
            srcD: `${STORAGE_CDN_PATH}/${path}/4-d.png/4-d.png`,
            srcT: `${STORAGE_CDN_PATH}/${path}/4-t.png/4-t.png`,
            src: `${STORAGE_CDN_PATH}/${path}/4-m.png/4-m.png`,
          }
        ]}
        onClick={handleCardClick}
        elementName='Преимущества'
        elementBlock={STORAGE_ELEMENT_BLOCK}
        textColor={variant === 'C' ? "text-invert" : undefined}
      />

      <Modal
        show={isOpen}
        onClose={handleCloseModal}
        size="m"
        variant="curtain"
      >
        <ModalHeader title={MODAL_CONTENT[activeCard].title} />
        <ModalContent>
          <Typography variant="m" size="body_long" adaptive={false}>
            {MODAL_CONTENT[activeCard].description}
          </Typography>
        </ModalContent>
      </Modal>
    </>
  );
};
